<template>
  <div class="viq-followups">
    <div v-if="!hideHeader" class="viq-followups__header">
      <span>Suggested follow-ups</span>
      <el-tooltip effect="dark" placement="top" :open-delay="300">
        <div slot="content">Questions generated from the context<br>of your previous question.</div>
        <span class="viq-followups__help-icon">?</span>
      </el-tooltip>
    </div>
    <div class="viq-followups__chips">
      <button
        v-for="(suggestion, i) in suggestions"
        :key="i"
        class="viq-followups__chip"
        @click="askFollowUp(suggestion)"
      >
        {{ typeof suggestion === 'string' ? suggestion : suggestion.text }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ViqFollowUps",
  props: {
    suggestions: {
      type: Array,
      required: true,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("Viq", ["activeConversation", "activeLens"]),
  },
  methods: {
    askFollowUp(suggestion) {
      const text = typeof suggestion === "string" ? suggestion : suggestion.text;
      this.$store.dispatch("Viq/askQuestion", {
        question: text,
        conversationId: this.activeConversation?.id || null,
        lensId: this.activeLens?.id || null,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-followups {
  margin-top: $viq-space-md;

  &__header {
    display: flex;
    align-items: center;
    gap: $viq-space-sm;
    font-size: $viq-font-sm;
    font-weight: 700;
    color: $viq-text-secondary;
    margin-bottom: $viq-space-sm;
  }

  &__help-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid $viq-text-muted;
    color: $viq-text-muted;
    font-size: 9px;
    font-weight: 700;
    cursor: help;
    line-height: 1;
    flex-shrink: 0;
  }

  &__label {
    display: block;
    font-size: $viq-font-xs;
    font-weight: 600;
    color: $viq-text-secondary;
    margin-bottom: $viq-space-sm;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  &__chips {
    display: flex;
    flex-wrap: wrap;
    gap: $viq-space-sm;
  }

  &__chip {
    padding: $viq-space-sm $viq-space-lg;
    background: $viq-bg-primary;
    border: 1.5px solid $viq-accent;
    border-radius: $viq-radius-full;
    font-size: $viq-font-sm;
    font-weight: 600;
    color: $viq-accent;
    cursor: pointer;
    transition: background 0.15s, color 0.15s, box-shadow 0.15s;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      background: $viq-accent;
      color: #fff;
      box-shadow: $viq-shadow-sm;
    }
  }
}
</style>
